<template>
  <div class="whole-school-emotion-analysis">
    <div class="flex-align-center" style="margin-bottom: 20px">
      <div class="record-title">全校情绪健康特征分析</div>
    </div>
    <!--特征分析表格-->
    <TableList
      style="width: 100%"
      :columns="tableColumns"
      :tableData="tableData"
      :loading="loading"
      :scroll="{}"
    />
    <!--趋势分析-->
    <div class="trend-analysis">
      <div class="trend-content">
        <div class="trend-title">
            <img
                src="@/assets/imgs/school/monthRecord/analyse.png"
                alt=""
                style="width: 14px; height: 14px; margin-right: 5px"
            />
            <span>趋势分析：</span>
        </div>
        <p class="trend-paragraph">
          本次分析基于{{ dateRangeText }}所有的学生关爱记录，完成全维度分类统计与深度分析，核心结论如下：<br/>
          <!-- 1.核心预警诱因高度集中，以身体与学业问题为首要关注方向<br/> -->
          <!-- 本次统计中，身体原因、学业原因是学生预警的两大核心诱因，占关爱记录的{{ coreRatio }}，是当前学生心理健康预警工作的核心攻坚方向。 -->
        </p>
        <!-- <p class="trend-paragraph">
            身体原因：占比{{ bodyRatio }}，位列所有预警原因首位，主要集中在学生意外受伤、睡眠饮食异常、身体不适引发的情绪波动等方面，是青春期学生心理问题最常见的外在表现形式，需重点关注学生身体不适背后的心理根源。
        </p>
        <p class="trend-paragraph">
            学业原因：占比{{ studyRatio }}，位列第二，核心集中在学业成绩波动、升学备考压力、学习动力不足、学习习惯适应不良等维度，与八年级学生面临的地理生物中考、全学科学业压力提升的阶段特征高度匹配，是引发学生情绪问题的重要现实诱因。2.次要预警诱因聚焦成长维度，人际与性格问题需常态化关怀
        </p>
        <p class="trend-paragraph">
            亲子关系、性格原因、人际关系：三类问题合计占关爱记录的25.40%，是学生成长阶段的典型心理风险诱因，需纳入日常班级关怀的常态化关注范围。<br />
            亲子关系问题：占比11.11%，核心为亲子沟通矛盾、家庭教养方式冲突、亲子情感联结不足等，是引发学生情绪问题的重要家庭环境因素。
        </p> -->
        <p class="trend-paragraph" v-for="(item, index) in topThreeList" :key="index">
            <!-- 学业原因：占比{{ studyRatio }}，位列第二，核心集中在学业成绩波动、升学备考压力、学习动力不足、学习习惯适应不良等维度，与八年级学生面临的地理生物中考、全学科学业压力提升的阶段特征高度匹配，是引发学生情绪问题的重要现实诱因。2.次要预警诱因聚焦成长维度，人际与性格问题需常态化关怀 -->
             {{item.reasonName}}：占比 {{item.ratio}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import TableList from '@comp/chart/TableList.vue'
import { getSchoolFeatureAnalysis } from '@api/monthReport'
import moment from 'moment'

// 原因对象 → 表格展示文本（空值兼容）
function reasonText(reason) {
  if (!reason || !reason.reasonName) return '--'
  return `${reason.reasonName} ${reason.ratio}`
}

export default {
  name: 'WholeSchoolEmotionAnalysis',
  components: {
    TableList,
  },
  props: {
    dateRange: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      tableColumns: [
        {
          title: '年级',
          dataIndex: 'grade',
          align: 'left',
          width: '25%',
        },
        {
          title: '首要原因',
          dataIndex: 'primary',
          align: 'left',
          width: '20%',
        },
        {
          title: '次要原因',
          dataIndex: 'secondary',
          align: 'left',
          width: '20%',
        },
        {
          title: '其他原因',
          dataIndex: 'other',
          align: 'left',
          width: '35%',
        },
      ],
      tableData: [],
      topThreeList: []
    }
  },
  watch: {
    dateRange: {
      immediate: true,
      handler(dateObj) {
        if (dateObj && dateObj.beginDate) {
          this.queryFeatureAnalysis({
            startTime: dateObj.beginDate,
            endTime: dateObj.endDate,
          })
        }
      },
    },
  },
  computed: {
    // 日期区间文本：如 2026年06月—2026年06月
    dateRangeText() {
      const format = (d) => (d ? moment(d).format('YYYY年MM月') : '')
      return `${format(this.dateRange.endDate)}`
    },
  },
  methods: {
    async queryFeatureAnalysis(params) {
      this.loading = true
      try {
        const { success, result } = await getSchoolFeatureAnalysis(params)
        if (success && result) {
          // 年级特征：primary/secondary/third 映射为表格三列
          this.tableData = (result.gradeFeatureList || []).map((item) => ({
            grade: item.gradeName,
            primary: reasonText(item.primaryReason),
            secondary: reasonText(item.secondaryReason),
            other: reasonText(item.thirdReason),
          }))
          this.topThreeList = result.schoolTopThree || []
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped lang="less">
.whole-school-emotion-analysis {
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  .emotion-table {
    ::v-deep(.ant-table-thead > tr > th) {
      background-color: #fafcff;
      font-weight: 600;
      color: #383838;
    }
    ::v-deep(.ant-table-tbody > tr > td) {
      color: #383838;
    }
  }
  .trend-analysis {
    margin-top: 24px;
    .trend-title {
      display: flex;
      align-items: center;
      color: #383838;
    }
    .trend-content {
      margin-top: 12px;
      padding: 16px 20px;
      border-radius: 11.75px;
      background-color: #fafcff;
      color: #383838;
      line-height: 32px;

      .trend-subtitle:first-child {
        margin-top: 0;
      }
      .trend-paragraph {
        margin-bottom: 30px;
      }
      .trend-paragraph:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
